import users from './Users'
import budgets from './Budgets'
import accounts from './Accounts'
import categories from './Categories'
import categoryGroups from './CategoryGroups'
import payees from './Payees'
import { budgetMonths, categoryMonths } from './BudgetMonths'
import app from './App'

export const reducers = {
  users,
  budgets,
  accounts,
  categories,
  categoryGroups,
  payees,
  budgetMonths,
  categoryMonths,
  app,
}
